<template>
    <div class="box7-1">
        <div class="container">
            <h2>企业级真实项目 技术直通一线前沿</h2>
            <p>直击企业核心业务，复现职场实战全貌</p>
            <div class="tab-bar">
                <div v-for="(item, idx) in slides" :key="idx" :class="['tab-item', { active: activeIndex === idx }]"
                    @click="onTabClick(idx)">
                    {{ item.title }}
                </div>
            </div>
            <swiper :options="swiperOption" ref="mySwiper" @slideChangeTransitionEnd="onSlideChange">
                <swiper-slide v-for="(item, idx) in slides" :key="idx">
                    <div class="slide-content">
                        <img :src="item.img" alt="" />

                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            activeIndex: 0,
            slides: [
                {
                    img: require('../../../assets/coursePage/agent/7-three.png'),
                    title: '天机助手',
                    desc: '7×24小时精准智能下单\n掌握SpringAI+多智能体架构...'
                },
                {
                    img: require('../../../assets/coursePage/agent/7-one.png'),
                    title: '美妆宝客服',
                    desc: '内容2...'
                },
                {
                    img: require('../../../assets/coursePage/agent/7-two.png'),
                    title: 'AI行政助理',
                    desc: '内容3...'
                }
            ],
            swiperOption: {
                loop: false,
                spaceBetween: 30,
                on: {
                    slideChangeTransitionEnd: () => {
                        this.onSlideChange();
                    }
                }
            }
        };
    },
    methods: {
        onTabClick(idx) {
            this.activeIndex = idx;
            this.$refs.mySwiper.swiper.slideTo(idx);
        },
        onSlideChange() {
            this.activeIndex = this.$refs.mySwiper.swiper.activeIndex;
        }
    }
};
</script>

<style lang="less" scoped>
.box7-1 {
    width: 100%;
    background: url("../../../assets/coursePage/agent/7-bg.png") center top no-repeat;
    background-size: cover;

    .container {
        padding: 32px 32px 80px;
    }

    h2 {
        font-size: 40px;
        text-align: center;
        color: white;
    }

    p {
        text-align: center;
        color: white;
        font-size: 24px;
        margin: 16px 0 50px;

    }

    .tab-bar {
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;
        background: #165dff;
        border-radius: 32px;

        .tab-item {
            padding: 12px 32px;
            font-size: 28px;
            color: #fff;
            border-radius: 32px;
            margin: 6px;
            cursor: pointer;
            transition: background 0.2s;
            flex: 1;
            text-align: center;

            &.active {
                background: #3a7afe;
                font-weight: bold;
            }
        }
    }

    .slide-content {
        text-align: center;

        img {
            width: 686px;
            height: 644px;
            display: block;
        }

        .slide-title {
            font-size: 42pt;
            font-weight: bold;
            margin: 20px 0 10px;
            color: #fff;
        }

        .slide-desc {
            font-size: 24px;
            color: #fff;
            white-space: pre-line;
        }
    }
}
</style>
